<template>
  <div>
    <el-form label-position="top">
      <el-form-item>
        <template v-slot:label>
          <p>
            订阅以下地区的标签：
            <ChooseCityComponent style="float:right"></ChooseCityComponent>
          </p>
        </template>

        <el-select
          v-model="tags"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="选择订阅标签"
          @change="updatingTags"
        >
          <el-option
            v-for="item in allTags"
            :key="item.id"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="subscribe" class="float-right">保存</el-button>
        &nbsp;
        <el-alert
          style="display:inline"
          v-if="updated"
          title="未保存"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
        <span>当新话题包含以下标签，您将收到邮件通知。</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ChooseCityComponent from "./ChooseCityComponent.vue";

export default {
  data() {
    return {
      tags: [],
      allTags: [],
      updated: false
    };
  },
  components: {
    ChooseCityComponent
  },
  methods: {
    ...mapMutations(["setLoading"]),
    goToTag(tag) {
      this.$router.push({
        path: "/tags/" + tag.id + "/" + tag.slug,
        query: { tagName: tag.name }
      });
    },
    getTags: function() {
      this.$http.get("/user/tags").then(res => {
        this.tags = res.data.map(tag => tag.name);
        this.updated = false;
      });
    },
    updatingTags: function() {
      this.updated = true;
    },
    subscribe: function() {
      this.setLoading(true);
      let self = this;
      this.$http
        .post("/user/tags", { tags: this.tags })
        .then(response => {
          //self.topic = response.data;
          self.setLoading(false);
          if (response.status == 201) {
            self.$message({
              type: "success",
              showClose: true,
              message: "标签订阅成功！"
            });
          }
          self.updated = false;
        })
        .catch(function(err) {
          self.setLoading(false);
          this.$message({
            type: "error",
            showClose: true,
            message: err.response.data
          })
        });
    },
    getAllTags: function() {
      if (this.allTags.length == 0) {
        //fetch all tags
        this.$axios.get("/tags?count=100").then(
          response =>
            (this.allTags = response.data.map(
              tag =>
                new Object({
                  value: tag.name,
                  id: tag.id
                })
            ))
        );
      }
    },
    handleClose: function(tag) {
      this.$confirm("确定退订该标签：" + tag.name + "?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http
          .delete("/user/tags/" + tag.id)
          .then(() => {
            this.$message({
              showClose: true,
              type: "success",
              message: "删除成功"
            });
            this.getTags();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: "error",
              message: "删除不成功，请稍后再试"
            });
          });
      });
    }
  },
  // set the layout to user when it's mounted.
  mounted: function() {
    this.getTags();
    this.getAllTags();
  }
};
</script>
